var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axiosInstance from '../../store/AxiosSingleton';
import { CentreInteret } from 'common/classes/CentreInteret.class';
import { Commentaire } from 'common/classes/commentaires/Commentaire.class';
import { GeoPays } from 'common/classes/geo/GeoPays.class';
import { GeoVille } from 'common/classes/geo/GeoVille.class';
import { Alerte } from 'common/classes/Alerte.class';
import { MentionLegale } from 'common/classes/mentionLegale/MentionLegale.class';
import { CGU } from 'common/classes/cgu/CGU';
import { FAQ } from 'common/classes/faq/FAQ.class';
export class CommonService {
    /**
     * Chargement de la liste des pays
     * @return Liste des pays récupérés
     */
    static listePays() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: CommonService.rubModule,
                    action: 'GEO_LISTE_PAYS',
                },
            });
            return content.map((p) => new GeoPays(p));
        });
    }
    /**
     * Recherche de villes
     * @return Liste des villes récupérées
     */
    static searchCity(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: CommonService.rubModule, action: 'GEO_SEARCH_CITY' }, request),
            });
            return content.map((p) => new GeoVille(p));
        });
    }
    /**
     * Charge une ville
     * @return Ville récupérée
     */
    static loadCity(idCity) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: CommonService.rubModule,
                    action: 'GEO_LOAD_CITY',
                    idCity,
                },
            });
            return content ? new GeoVille(content) : null;
        });
    }
    /**
     * Recherche une ville et son pays à partir d'une position GPS
     * @param position Longitude et latitude
     * @return Ville et pays trouvé
     */
    static findByPosition(position) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: CommonService.rubModule, action: 'FIND_VILLE_BY_POSITION' }, position),
            });
            return {
                ville: new GeoVille(content.ville),
                pays: new GeoPays(content.pays),
            };
        });
    }
    /**
     * Ajout d'un signalement
     * @param alerte Alerte à insérer
     * @return True si l'opération a réussie, false sinon
     */
    static addAlerte(alerte) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!alerte) {
                return null;
            }
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                alerte,
            }, {
                params: {
                    rub: CommonService.rubModule,
                    action: 'SAVE_ALERTE',
                },
            });
            return new Alerte(content);
        });
    }
    /**
     * Supprime un signalement
     * @param idAlerte Identifiant de l'alerte à supprimer
     * @return True si l'opération a réussie, false sinon
     */
    static deleteAlerte(idAlerte) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: CommonService.rubModule,
                    action: 'DELETE_ALERTE',
                    idAlerte,
                },
            });
            return content;
        });
    }
    /**
     * Récupère des centres d'intérêts à partir d'une chaine de caractères
     * @param centreInteretString Chaine de caractères à rechercher
     * @return Liste de centres d'intérêts
     */
    static loadCentreInteret(centreInteretString) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: CommonService.rubModule,
                    action: 'LOAD_CENTRE_INTERETS',
                    centreInteretString,
                },
            });
            return content.map((centreInteret) => new CentreInteret(centreInteret));
        });
    }
    /**
     * Charge les commentaires d'une section
     * @param request Paramètres de la requête
     * @return Liste des commentaires et total des commentaires
     */
    static loadComments(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: CommonService.rubModule, action: 'LOAD_COMMENTS' }, request),
            });
            return {
                comments: content.comments.map((commentData) => new Commentaire(commentData)),
                total: content.total,
            };
        });
    }
    /**
     * Envoi un nouveau commentaire
     * @param commentaire Commentaire à insérer
     * @return True si insertion réussi, false sinon
     */
    static postComment(commentaire) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!commentaire) {
                return false;
            }
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                commentaire: commentaire.toRaw(),
            }, {
                params: {
                    rub: CommonService.rubModule,
                    action: 'POST_COMMENT',
                },
            });
            return content;
        });
    }
    /**
     * Supprime un commentaire
     * @param idCommentaire Identifiant du commentaire à supprimer
     * @param idRaison Identifiant de la raison de la suppression
     * @return True si validation réussi, false sinon
     */
    static deleteComment(idCommentaire, idRaison) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!idCommentaire) {
                return false;
            }
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: CommonService.rubModule,
                    action: 'DELETE_COMMENT',
                    idCommentaire,
                    idRaison,
                },
            });
            return content;
        });
    }
    /**
     * Modifie un commentaire
     * @param commentaire Commentaire à modifier
     * @return True si modification réussi, false sinon
     */
    static editComment(commentaire) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!commentaire) {
                return false;
            }
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                commentaire: commentaire.toRaw(),
            }, {
                params: {
                    rub: CommonService.rubModule,
                    action: 'EDIT_COMMENT',
                },
            });
            return content;
        });
    }
    /**
     * Like un commentaire
     * @param commentID Identifiant du commentaire à liker
     * @return True si l'opération a réussi, false sinon
     */
    static likeComment(commentID) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { commentID }, {
                params: {
                    rub: CommonService.rubModule,
                    action: 'LIKE_COMMENT',
                },
            });
            return content;
        });
    }
    /**
     * Retirer le like d'un commentaire
     * @param commentID Identifiant du commentaire à unliker
     * @return True si l'opération a réussi, false sinon
     */
    static unlikeComment(commentID) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: CommonService.rubModule,
                    action: 'UNLIKE_COMMENT',
                    commentID,
                },
            });
            return content;
        });
    }
    /**
     * Ajouter une nouvelle visite
     * @param table Nom de la table où réaliser l'insertion
     * @param idRef Identifiant de l'objet visité
     * @param idCreateur Identifiant de l'utilisateur ayant effectué la visite
     * @return True si l'opération a réussi, false sinon
     */
    static addVisite(table, idRef, idCreateur) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                table,
                idRef,
                idCreateur,
            }, {
                params: {
                    rub: CommonService.rubModule,
                    action: 'ADD_VISITE',
                },
            });
            return content;
        });
    }
    /**
     * Cherche un pays par rapport à son code
     * @param code Code du pays (FR, CH, BE ...)
     * @return Pays trouvé
     */
    static findPaysByCode(code) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: CommonService.rubModule,
                    action: 'FIND_PAYS_BY_CODE',
                    code,
                },
            });
            return new GeoPays(content);
        });
    }
    /**
     * Cherche un pays par rapport à son identifiant
     * @params Identifiant du pays
     * @return Pays trouvé
     */
    static findPays(idPays) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: CommonService.rubModule,
                    action: 'FIND_PAYS',
                    idPays,
                },
            });
            return new GeoPays(content);
        });
    }
    /**
     * Cherche un pays à partir de l'identifiant d'une ville
     * @params Identifiant de la ville
     * @return Pays trouvé
     */
    static findPaysByVille(idVille) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: CommonService.rubModule,
                    action: 'FIND_PAYS_BY_VILLE',
                    idVille,
                },
            });
            return new GeoPays(content);
        });
    }
    /**
     * Ajoute une prise de contact
     * @param formContactRow Objet de prise de contact
     * @return True si l'opération a réussie, false sinon
     */
    static addFormContact(formContactRow) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                formContactRow,
            }, {
                params: {
                    rub: CommonService.rubModule,
                    action: 'SAVE_FORM_CONTACT',
                },
            });
            return content;
        });
    }
    /**
     * Récupère les mentions légales de l'application
     * @return La liste des mentions légales
     */
    static loadMentionsLegales() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: CommonService.rubModule,
                    action: 'LOAD_MENTIONS_LEGALES',
                },
            });
            return content.map((mention) => new MentionLegale(mention));
        });
    }
    /**
     * Récupère les Conditions Générales d'Utilisations de l'application
     * @return La liste des conditions générales d'utilisation
     */
    static loadCGU() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: CommonService.rubModule,
                    action: 'LOAD_CGU',
                },
            });
            return content.map((cgu) => new CGU(cgu));
        });
    }
    /**
     * Récupère la FAQ
     * @return La liste des questions de la FAQ
     */
    static loadFAQ() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: CommonService.rubModule,
                    action: 'LOAD_FAQ',
                },
            });
            return content.map((faq) => new FAQ(faq));
        });
    }
}
CommonService.rubModule = 'common';
//# sourceMappingURL=data:application/json;base64,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